import React from "react";
import "./primarySectionStyle.scss";

const PrimarySection = ({ children }) => {
  return <div className="primary-container">{children}</div>;
};

export default PrimarySection;
